export const getLocalizedRoute = (route: string, language?: string) =>
  language ? `/${language.toLowerCase()}${route}` : route;
